import { Button } from "@mui/material";
import { useState } from "react";
import { Order } from "../../api/api-generated";
import LicensesDialog from "./LicensesDialog";

interface Props {
  order?: Order;
}

const LicensesButton = ({ order }: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const handleOpen = (event: React.MouseEvent) => {
    event.stopPropagation();
    setDialogOpen(true);
  };
  return (
    <>
      <Button onClick={handleOpen} variant="outlined" color="primary">
        Licenses
      </Button>
      {dialogOpen && (
        <LicensesDialog
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          order={order}
        />
      )}
    </>
  );
};

export default LicensesButton;
